import { render, staticRenderFns } from "./VipLesson.vue?vue&type=template&id=3db5e62b&scoped=true&"
import script from "./VipLesson.vue?vue&type=script&lang=js&"
export * from "./VipLesson.vue?vue&type=script&lang=js&"
import style0 from "./VipLesson.vue?vue&type=style&index=0&id=3db5e62b&prod&lang=scss&"
import style1 from "./VipLesson.vue?vue&type=style&index=1&id=3db5e62b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db5e62b",
  null
  
)

export default component.exports